import { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo from '../../../../assets/images/logo.svg'
import savedIcon from '../../../../assets/icons/saved.svg'
import SearchInput from '../../search-input'
import './styles.sass'
import { UserdataContext } from '../../../../App'


export const MobileHeader = () => {
    const [openedMenu, setOpenedMenu] = useState<boolean>(false)
  
    useEffect(() => {
      document.addEventListener('click', e => {
        const target = e.target as HTMLElement;
        const menuBtn = document.querySelector('.menu-btn') as HTMLElement;
        const searchInput = document.querySelector('.oportunities-searcher') as HTMLElement;
  
        if(searchInput && searchInput.contains(target) && target.className !== 'search-icon') return;
  
        if(menuBtn && menuBtn.contains(target)) {
          setOpenedMenu(!menuBtn.classList.contains('opened'));
        } else {
          setOpenedMenu(false);
        };
      });
    }, [])
  
    return (
      <header className='mobile'>
        <div className={'menu-btn '+(openedMenu ? 'opened' : '')}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <Link to=''><img className='logo' alt='logo' src={logo} /></Link>
        <Menu openedMenu={openedMenu} />
      </header>
    )
}
  
const Menu = ({ openedMenu }: { openedMenu: boolean }) => {
    const navigate = useNavigate()
    const {userData, setUserData} = useContext<any>(UserdataContext)
    const usertypes: any = {
      'candidate': 'Candidato',
      'job_manager': 'Empresa'
    }

    const onLogout = () => {
      localStorage.removeItem('user_id');
      localStorage.removeItem('candidate_id');
      localStorage.removeItem('manager_id');
      localStorage.removeItem('legacy_password_login');
      localStorage.removeItem('auth_token');
      sessionStorage.clear();
      setUserData(null);
      navigate('/login');
    }
  
    return (
      <div className={'menu '+(openedMenu ? 'opened' : '')}>
        {
          userData &&
          <div className='user-data'>
            <div>
              <h4>Olá, <b>{userData.full_name}</b></h4>
              <p>{usertypes[userData.usertype]}</p>
            </div>
            <div className='profile-picture-container'>
              {userData.picture && <img src={userData.picture} alt='user-picture' />}
            </div>
          </div>
        }
        {!userData &&
        <ul className='unlogged-links'>
          <Link to='sign-up'><li>Cadastro</li></Link>
          <Link to='login'><li>Entre</li></Link>
        </ul>}
        {userData?.usertype === 'candidate' &&
        <SearchInput />}
        <ul className='home-links'>
          <Link to='how-to-anounce'>
            <li>Como anunciar</li>
          </Link>
          <Link to='about-us'>
            <li>Sobre nós</li>
          </Link>
          <Link to='success-stories'>
            <li>Histórias</li>
          </Link>
        </ul>
        {userData?.usertype === 'candidate' &&
        <ul className='offer-links'>
          <Link to='offers'>
            <li>
              <span>Vagas</span>
            </li>
          </Link>
          <Link to='profile/candidate/subscriptions'>
            <li>
              <span>Vagas salvas</span>
            </li>
          </Link>
          <Link to='job-subscriptions'>
            <li>
              <span>Candidaturas</span>
            </li>
          </Link>
        </ul>}
        {userData?.usertype === 'job_manager' &&
        <ul className='offer-links'>
          <Link to='offers/create'>
            <li>
              <span>Cadastrar vagas</span>
            </li>
          </Link>
          <Link to='offers'>
            <li>
              <span>Minhas vagas</span>
            </li>
          </Link>
        </ul>}
        {
          userData &&
          <ul>
            <Link to={userData.usertype === 'candidate' ? 'profile/candidate/person' : 'profile/company/user'}><li>Meu perfil</li></Link>
            <li onClick={onLogout}>Sair</li>
          </ul>
        }
      </div>
    )
}
  